import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-awarded-collections',
    templateUrl: './awarded-collections.component.html',
    styleUrls: ['./awarded-collections.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, TranslatePipe],
})
export class AwardedCollectionsComponent {}
